module.exports = __webpack_public_path__ + "static/media/Lucy.c2ee6f04.png";